module.exports = __webpack_public_path__ + "static/media/skip_button@3x.9787a7e3.png";